/*** IMPORTS FROM imports-loader ***/
var _ = require("underscore/underscore");

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p +=
((__t = ( begin_tab('Details', {open: true, html_options: {'id': 'details'}}))) == null ? '' : __t) +
'\n	<form class="form-horizontal" id="form" data-ajax="false">\n		' +
((__t = ( input_for(model, 'id', 'hidden'))) == null ? '' : __t) +
'\n		' +
((__t = ( createView({
			model: model,
			organizations: organizations,
			isAdmin: isAdmin
		}))) == null ? '' : __t) +
'\n	</form>\n\n	<i> Modify the user\'s authentication details or ban the user in <a href="https://manage.auth0.com/dashboard/us/dev-xadw-1di/users"> Auth0. </a> </i>\n' +
((__t = ( end_tab())) == null ? '' : __t) +
'\n\n<!-- @todo remove the logic underneath this as well-->\n<!-- ' +
((__t = ( begin_tab('Password Change', {html_options: {'id': 'passwordChange'}}))) == null ? '' : __t) +
'\n	<form class="form-horizontal" id="password-form" data-ajax="false">\n		' +
((__t = ( input_for(model, 'Username', 'hidden'))) == null ? '' : __t) +
'\n		';
if(isAdmin){;
__p += '\n			' +
((__t = ( form_group_for(passwordModel, 'newPassword', 'Set Password', 'password'))) == null ? '' : __t) +
'\n		';
} else {;
__p += '\n			' +
((__t = ( form_group_for(passwordModel, 'oldPassword', 'Old Password', 'password'))) == null ? '' : __t) +
'\n			' +
((__t = ( form_group_for(passwordModel, 'newPassword', 'New Password', 'password'))) == null ? '' : __t) +
'\n			' +
((__t = ( form_group_for(passwordModel, 'confirmPassword', 'Confirm Password', 'password'))) == null ? '' : __t) +
'\n		';
};
__p += '\n		<div class="form-group">\n            <input type="button" class="change-password-button btn btn-default" value="Change Password" />\n        </div>\n	</form>\n' +
((__t = ( end_tab())) == null ? '' : __t) +
'\n';
 if(isAdmin){;
__p += '\n	' +
((__t = ( begin_tab('Groups', {html_options: {'id': 'permissions'}}))) == null ? '' : __t) +
'\n	' +
((__t = ( end_tab())) == null ? '' : __t) +
'\n';
 };
__p += ' -->';

}
return __p
}



//////////////////
// WEBPACK FOOTER
// ./public/views/admin/users/Edit.ejs
// module id = 869
// module chunks = 1